var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center min-vh-100"},[_c('CContainer',{attrs:{"fluid":""}},[_c('CRow',{staticClass:"justify-content-center"},[_c('CCol',{attrs:{"md":"6"}},[_c('h1',[_vm._v("メールアドレス認証")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }